const config = {
  dataUrl: '/node/home/api/recommended-properties',
  options: {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }
};

const DEFAULT_RECOMMENDED_PROPERTY = {
  data: []
};

const getRecommendedProperties = siteName =>
  fetch(`${config.dataUrl}?site=${siteName}`, config.options)
    .then(response => response.json())
    .catch(() => DEFAULT_RECOMMENDED_PROPERTY);

export { getRecommendedProperties, config };
